import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "bars", "label", "submit"]

  check() {
    const password = this.inputTarget.value
    const score = this.score(password)
    const bars = this.barsTarget.children
    const levels = [
      { color: "bg-red-400", label: "Weak", textColor: "text-red-400" },
      { color: "bg-orange-400", label: "Fair", textColor: "text-orange-400" },
      { color: "bg-indigo-400", label: "Good", textColor: "text-[#6366f1]" },
      { color: "bg-sky-400", label: "Strong", textColor: "text-sky-400" },
    ]

    for (let i = 0; i < bars.length; i++) {
      bars[i].className = "h-0.5 flex-1 rounded-full bg-gray-200 transition-colors duration-300"
    }

    const base = "absolute right-4 top-1/2 -translate-y-1/2 text-[10px] tracking-wide pointer-events-none"

    if (password.length === 0) {
      this.labelTarget.textContent = ""
      this.labelTarget.className = base
      this.submitTarget.classList.add("disabled")
      this.submitTarget.disabled = true
      return
    }

    const level = levels[score - 1]
    for (let i = 0; i < score; i++) {
      bars[i].className = `h-0.5 flex-1 rounded-full ${level.color} transition-colors duration-300`
    }
    this.labelTarget.textContent = level.label
    this.labelTarget.className = `${base} ${level.textColor}`

    const ok = score >= 3 && password.length >= 8
    this.submitTarget.disabled = !ok
    this.submitTarget.classList.toggle("disabled", !ok)
  }

  // Mirrors the server-side PasswordStrength.score (Task 2): <8 chars = 1,
  // otherwise base 2 plus a point each for a digit and a symbol (max 4).
  score(pw) {
    if (pw.length < 8) return 1
    let s = 2
    if (/\d/.test(pw)) s++
    if (/[^a-zA-Z0-9]/.test(pw)) s++
    return s
  }
}
